module.exports = __webpack_public_path__ + "img/grupTurcoaz.10f65fd8.svg";